import React from "react";

const CTASection = () => (
  <section id="contact" className="py-20 bg-slate-900">
    <div className="max-w-4xl mx-auto px-4 text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
        Ready to join the team?
      </h2>
      <p className="text-blue-100 text-lg mb-10">
        We are always looking for talented individuals to join our growing
        family. Check out our open positions.
      </p>
      <button className="bg-white text-slate-900 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition shadow-lg transform hover:-translate-y-1">
        View Open Roles
      </button>
    </div>
  </section>
);

export default CTASection;
